module.exports = __webpack_public_path__ + "assets/src/assets/downloads/Bedrock Capabilities.pdf";